// src/modules/app-views/ticket-events/pages/Document/decorators/responseDoc.js
import dayjs from 'dayjs';

const decorateResponseDoc = doc => {
  if (!doc) return doc;

  const result = { ...doc };

  // Compose salePeriod RangePicker value from saleStartDate + saleEndDate
  if (result.saleStartDate && result.saleEndDate) {
    result.salePeriod = [dayjs(result.saleStartDate), dayjs(result.saleEndDate)];
  }

  // Convert eventDate string to dayjs
  if (result.eventDate) {
    result.eventDate = dayjs(result.eventDate);
  }

  return result;
};

export default decorateResponseDoc;
